module.exports = "### How does React work?\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/09_how_it_works/notes_1.md
// module id = 1515
// module chunks = 0